import { render, staticRenderFns } from "./CambiarEstado.vue?vue&type=template&id=eb25d0f4&"
import script from "./CambiarEstado.vue?vue&type=script&lang=js&"
export * from "./CambiarEstado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports